// extracted by mini-css-extract-plugin
module.exports = {"verticalText":"styles_verticalText__1oINr","entityHeader":"styles_entityHeader__3wPzc"};